import styled from 'styled-components';
import { palette } from 'styled-theme';

export const NotificationWrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-shrink: 0;

  &:hover {
    opacity: 0.9;
  }
`;

export const NotificationBadgeWrapper = styled('div')`
  &.is-max-amount {
    .notifications-count {
      font-size: 9px !important;
    }
  }
`;

export const ButtonWrapper = styled('div')`
  background: ${palette('grayscale', 4)};
  display: flex;
  align-items: center;
`;

export const SpinWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 128px 0;
  position: absolute;
  width: 100%;
  pointer-events: none;
  margin: 47px 0;
`;
